import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { api, type RedemptionListParams } from '@/lib/api-client'

/** Paginated list of patients with outstanding sessions + summary stats. */
export function useRedemption(params?: RedemptionListParams) {
  return useQuery({
    queryKey: ['redemption', params],
    queryFn: () => api.redemption.list(params),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  })
}

/** Per-patient detail: per-promo breakdown + visit timeline. */
export function useRedemptionDetail(patientId: number | null) {
  return useQuery({
    queryKey: ['redemption-detail', patientId],
    queryFn: () => api.redemption.get(patientId!),
    enabled: patientId !== null && patientId > 0,
    staleTime: 60 * 1000,
  })
}
